// extracted by mini-css-extract-plugin
module.exports = {"editorInfoMessage":"ReactPlayground-EditorInfoMessage-module--editor-info-message--3R6MO p-2 alert alert-info"};